import moment from 'moment';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getMMDDYY = (timestamp: number = 0, format: string = `MMMM Do YYYY, h:mm:ss a`) => {
  return moment(timestamp * 1000)
    .utcOffset(1)
    .format(format);
};

export const getCurrentDayYear = () => {
  const d = new Date();
  return {
    date: d.getDate(),
    month: d.getMonth(),
    year: d.getFullYear(),
  };
};

export const formatDate = (val: number) => {
  const d = new Date(val * 1000);
  const split = d.toString().split(' ');

  const day = split[2];
  const month = split[1];
  const year = split[3];
  const hrs = d.getHours();
  const min = d.getMinutes();

  const readableDate = `${day} ${month}, ${year}`;
  const time = `${hrs}:${min} ${hrs > 11 ? 'PM' : 'AM'}`;

  return {
    readableDate,
    time,
  };
};
